import styles from './ComparisonCard.module.scss'
import { ComparisonCardProps } from './types.ts'

const ComparisonCard = ({ data, description, icon }: ComparisonCardProps) => {
  return (
    <div>
      <div className={styles['energy-comparison-card']}>
        <div className={styles.icon}>{icon}</div>
        <h3 className={styles.data}>{data}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  )
}

export default ComparisonCard
